// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__zVunP","Footer":"footer_Footer__S5Ahx","topblock":"footer_topblock__OUkN+","copyright":"footer_copyright__vVcHP"};